"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAPPED_TO_PROPS = exports.ATTRIBUTES = void 0;
var ATTRIBUTES = ['component-id', 'listen-to', 'path', 'context', 'context-modifier', 'key', 'dangerouslySetInnerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'alt', 'async', 'autocomplete', 'autofocus', 'autoplay', 'capture', 'checked', 'default', 'defer', 'disabled', 'draggable', 'dropzone', 'hidden', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'is', 'maxlength', 'minlength', 'media', 'method', 'multiple', 'name', 'placeholder', 'readonly', 'rel', 'required', 'reversed', 'role', 'rows', 'rowspan', 'selected', 'slot', 'src', 'tabindex', 'target', 'title', 'type', 'value'];
exports.ATTRIBUTES = ATTRIBUTES;
var MAPPED_TO_PROPS = ['value'];
exports.MAPPED_TO_PROPS = MAPPED_TO_PROPS;